import React, { useEffect } from 'react';
import cn from 'classnames';
import type { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ErrorIcon } from '../../../components/error-icon';
import { defaultErrorOverlimitCountdownDesktopSettings } from '../config/default-values';
import type { TErrorOverlimitCountdownDesktop } from '../model';
import { formatMsAsMinutes, useCountdown } from '../utils';
import { routeSwitch, selectAppMeta, type TDispatch } from '../../../store';
import { CountdownLoader } from '../../../components/countdown-loader';
import { formSteps } from '../../../config';

import styles from './styles.css';

export const ErrorOverlimitCountdownDesktop: FC<TErrorOverlimitCountdownDesktop> = ({
    Aligner,
    Text,
    description = defaultErrorOverlimitCountdownDesktopSettings.description,
    subtitle = defaultErrorOverlimitCountdownDesktopSettings.subtitle,
}) => {
    const dispatch = useDispatch<TDispatch>();
    const { overlimitFormBlockingCountdownMs = 0 } = useSelector(selectAppMeta);
    const [timeLeft, startTimer] = useCountdown(overlimitFormBlockingCountdownMs);

    useEffect(() => {
        startTimer();
    }, [startTimer]);

    useEffect(() => {
        const asyncEffect = async () => {
            if (timeLeft <= 0) {
                await dispatch(routeSwitch(formSteps.init));
            }
        };
        asyncEffect();
    }, [timeLeft, dispatch]);

    return (
        <Aligner>
            <ErrorIcon />
            <Text styler={{ marginBottom: 32, marginTop: 24 }} tag="h2" view="small">
                {subtitle}
            </Text>
            <Text styler={{ marginTop: 0, marginBottom: 0 }} view="primary-medium">
                {description}
            </Text>
            <Aligner className={cn(styles.counter, styles.external)}>
                <CountdownLoader progress={1 - timeLeft / overlimitFormBlockingCountdownMs} />
                <></>
                <Text
                    styler={{ marginTop: 0, marginBottom: 0, marginLeft: 4 }}
                    view="primary-medium"
                >
                    {formatMsAsMinutes(timeLeft)}
                </Text>
            </Aligner>
        </Aligner>
    );
};
